module.exports = __webpack_public_path__ + "static/dsb-dd1fe5bf7d94a7e7c23faa42629b73ad.png";